import { get } from './request';

export default {
  getRedirectLinks (params) {
    return get('/redirect-links', { params });
  },
};
